import { post } from '@tencent/pmd-network';
import { isTestEnv } from '@tencent/pmd-tools/lib/env';

/**
 * 拉取前端七彩石配置
 * 七彩石地址：http://rainbow.oa.com/console/2d3cc7f5-8a20-4588-9d94-02c2a562860d/Default/list?group_id=227318&group_name=tip.prod.frontconfig
 * @param key 七彩石配置项的key（正式环境）
 * @param testKey 测试环境的key，默认不传是key+'_test'，可以指定
 * @returns {Promise<unknown>} 配置数据（Json对象）
 */
export function getFrontConfig(key, testKey = null) {
  return new Promise((resolve, reject) => {
    const isTest = isTestEnv();

    const reqData = {
      key: isTest
        ? testKey
          ? testKey
          : `${key}_test`
        : key,
    };
    post({
      showMsgToast: false,
      url: isTest
        ? 'https://api-test.nes.smoba.qq.com/tipmp.user.commreport.commreport/FrontConfig'
        : 'https://api.nes.smoba.qq.com/tipmp.user.commreport.commreport/FrontConfig',
      oldCGI: true,
      reqData,
    })
      .then((res) => {
        let result = {};
        if (res.r === 0 && res.value) {
          try {
            result = JSON.parse(res.value);
          } catch (e) {
            console.log(e);
            reject(e);
          }
        }
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
